import { Pipe } from '@angular/core';
@Pipe({
  name: "phone"
})
export class PhonePipe {
  transform(rawNum) {
    //rawNum = rawNum.charAt(0) != 0 ? "0" + rawNum : "" + rawNum;

    let newStr = '';
    let i = 0;
    let indicative = '';
    let newPhoneNumber = '';
    newPhoneNumber = rawNum.slice(2,10);
    for (; i < Math.floor(newPhoneNumber.length / 3) - 1; i++) {
      newStr = newStr + newPhoneNumber.substr(i * 3, 3) + "-";
    }
    indicative = rawNum.substr(0,2);
    return '(+'+ indicative+') ' + newStr + newPhoneNumber.substr(i * 3);
  }
}
